import * as React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link as MuiLink,
  IconButton,
  Divider,
} from "@mui/material";
import { Link } from "react-router-dom";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import Chemitek from "../images/chemitek-1.png";

const NAV_LINKS = [
  { label: "Препарати", to: "/preparati-za-solarni-paneli" },
  { label: "Заяви оферта", to: "/oferta-na-preparati-za-solarni-paneli" },
  { label: "Услуги", to: "/uslugi-solarni-paneli" },
  { label: "Контакти", to: "/contacts" },
];

const SOCIAL_LINKS = [
  {
    label: "Facebook на TC Energy",
    href: "https://www.facebook.com/tc.energy.solar.cleaning.solutions",
    Icon: FacebookIcon,
  },
  {
    label: "LinkedIn на TC Energy",
    href: "https://www.linkedin.com/company/tc-energy-solar-clean-solutions",
    Icon: LinkedInIcon,
  },
  {
    label: "Instagram на TC Energy",
    href: "https://www.instagram.com/tc.energy.clean.solutions",
    Icon: InstagramIcon,
  },
];

export default function FooterModern() {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        mt: 0,
        color: "#ffffff",
        background:
          "linear-gradient(135deg, #102846 0%, #173b67 58%, #204c7d 100%)",
        borderTop: "4px solid #f2d35c",
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 3, sm: 4 }, py: { xs: 5, md: 7 } }}>
        <Grid
          container
          spacing={{ xs: 4, md: 5 }}
          alignItems="flex-start"
          justifyContent="space-between"
        >
          {/* Навигация */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              component="h2"
              variant="subtitle1"
              fontWeight={800}
              mb={2}
              sx={{ color: "#f2d35c", letterSpacing: "0.04em" }}
            >
              БЪРЗИ ВРЪЗКИ
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: { xs: "center", sm: "flex-start" },
                gap: 1.25,
              }}
            >
              {NAV_LINKS.map((item) => (
                <MuiLink
                  key={item.to}
                  component={Link}
                  to={item.to}
                  underline="none"
                  sx={{
                    color: "rgba(255,255,255,0.86)",
                    fontSize: "0.96rem",
                    transition: "color 160ms ease, transform 160ms ease",
                    "&:hover": {
                      color: "#f2d35c",
                      transform: "translateX(3px)",
                    },
                    "&:focus-visible": {
                      outline: "2px solid #f2d35c",
                      outlineOffset: "4px",
                      borderRadius: "2px",
                    },
                  }}
                >
                  {item.label}
                </MuiLink>
              ))}
            </Box>
          </Grid>

          {/* Контакти */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography
              component="h2"
              variant="subtitle1"
              fontWeight={800}
              mb={2}
              textAlign={{ xs: "center", sm: "left" }}
              sx={{ color: "#f2d35c", letterSpacing: "0.04em" }}
            >
              СВЪРЖЕТЕ СЕ С НАС
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: { xs: "center", sm: "flex-start" },
                gap: 1.75,
              }}
            >
              <Box display="flex" alignItems="center" gap={1.25}>
                <MarkEmailReadIcon sx={{ color: "#f2d35c", fontSize: 21 }} />
                <MuiLink
                  href="mailto:info@tcenergy.bg"
                  underline="hover"
                  sx={{
                    color: "#ffffff",
                    overflowWrap: "anywhere",
                    "&:hover": { color: "#f2d35c" },
                  }}
                >
                  info@tcenergy.bg
                </MuiLink>
              </Box>

              <Box display="flex" alignItems="center" gap={1.25}>
                <PhoneIphoneIcon sx={{ color: "#f2d35c", fontSize: 21 }} />
                <MuiLink
                  href="tel:+359884955699"
                  underline="hover"
                  sx={{
                    color: "#ffffff",
                    "&:hover": { color: "#f2d35c" },
                  }}
                >
                  +359 884 955 699
                </MuiLink>
              </Box>

              <Typography
                variant="body2"
                sx={{
                  mt: 0.5,
                  color: "rgba(255,255,255,0.68)",
                  textAlign: { xs: "center", sm: "left" },
                  lineHeight: 1.7,
                  maxWidth: 330,
                }}
              >
                Препарати и решения за професионална грижа за соларни панели.
              </Typography>
            </Box>
          </Grid>

          {/* Бранд и социални мрежи */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: { xs: "center", md: "flex-end" },
                textAlign: { xs: "center", md: "right" },
                gap: 1.5,
              }}
            >
              <Box
                sx={{
                  minHeight: 72,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  px: 2,
                  py: 1,
                  borderRadius: 2,
                  backgroundColor: "rgba(255,255,255,0.96)",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.16)",
                  transition: "transform 180ms ease",
                  "&:hover": { transform: "translateY(-2px)" },
                }}
              >
                <Box
                  component="img"
                  src={Chemitek}
                  alt="Chemitek"
                  sx={{
                    display: "block",
                    maxWidth: { xs: 190, md: 210 },
                    width: "100%",
                    maxHeight: 58,
                    objectFit: "contain",
                  }}
                />
              </Box>

              <Typography
                variant="body2"
                sx={{ color: "rgba(255,255,255,0.72)", maxWidth: 290 }}
              >
                Последвайте TC Energy в социалните мрежи.
              </Typography>

              <Box display="flex" gap={1}>
                {SOCIAL_LINKS.map(({ label, href, Icon }) => (
                  <IconButton
                    key={label}
                    component="a"
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    sx={{
                      color: "#f2d35c",
                      border: "1px solid rgba(242,211,92,0.38)",
                      backgroundColor: "rgba(255,255,255,0.04)",
                      transition:
                        "background-color 160ms ease, color 160ms ease, transform 160ms ease",
                      "&:hover": {
                        color: "#102846",
                        backgroundColor: "#f2d35c",
                        transform: "translateY(-2px)",
                      },
                      "&:focus-visible": {
                        outline: "2px solid #ffffff",
                        outlineOffset: "3px",
                      },
                    }}
                  >
                    <Icon />
                  </IconButton>
                ))}
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: { xs: 4, md: 5 }, borderColor: "rgba(255,255,255,0.16)" }} />

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1.5,
            textAlign: "center",
          }}
        >
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.72)" }}>
            © {currentYear} „Ти Си Енерджи“ ЕООД. Всички права запазени.
          </Typography>

          <Typography
            variant="caption"
            sx={{ color: "rgba(255,255,255,0.55)", letterSpacing: "0.02em" }}
          >
            Грижа за чисти панели. Решения за по-добра ефективност.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
